import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:5001'
  : '';

export default function LouderHubView() {
  const navigate = useNavigate();
  const sessionStr = localStorage.getItem('louder_session');
  const user = sessionStr ? JSON.parse(sessionStr) : { name: 'Team Member' };

  const [mailerCount, setMailerCount] = useState(0);
  const [metaRequestsCount, setMetaRequestsCount] = useState(0);
  const [metaClientsCount, setMetaClientsCount] = useState(0);
  const [totalLeadsCount, setTotalLeadsCount] = useState(0);

  useEffect(() => {
    // Fetch Mailer Templates Count
    fetch(`${BACKEND_URL}/api/templates`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setMailerCount(data.length);
      })
      .catch(() => {});

    // Fetch Meta Access Stats
    fetch(`${BACKEND_URL}/api/meta-access/requests`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.requests)) {
          setMetaRequestsCount(data.requests.length);
        }
      })
      .catch(() => {});

    fetch(`${BACKEND_URL}/api/meta-access/clients`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.clients)) {
          setMetaClientsCount(data.clients.length);
          const totalLeads = data.clients.reduce((acc, curr) => acc + (curr._count?.leadSubmissions || 0), 0);
          setTotalLeadsCount(totalLeads);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f7fa', color: '#1f2937', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 24px' }}>
        {/* Welcome Hero Banner */}
        <div style={{
          background: 'linear-gradient(135deg, #181126 0%, #2a1b4e 50%, #4c1d95 100%)',
          borderRadius: '28px',
          padding: '40px 48px',
          color: '#ffffff',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 20px 40px -10px rgba(76, 29, 149, 0.25)',
          marginBottom: '36px'
        }}>
          <div style={{ position: 'relative', zIndex: 2, maxWidth: '650px' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '700',
              color: '#fbbf24',
              marginBottom: '16px'
            }}>
              ⚡ LOUDER OPERATIONS & MARKETING HUB
            </div>
            <h1 style={{ fontSize: '32px', fontWeight: '800', margin: '0 0 12px 0', letterSpacing: '-0.02em' }}>
              Welcome back, {user.name || 'Team'}
            </h1>
            <p style={{ fontSize: '15px', color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6', margin: 0 }}>
              Your central workspace for all internal Louder business tools. Create email campaigns, onboard artist managers with single links, and manage business workflows.
            </p>
          </div>

          {/* Decorative Background Circles */}
          <div style={{
            position: 'absolute',
            right: '-40px',
            bottom: '-40px',
            width: '280px',
            height: '280px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(217, 119, 6, 0.3) 0%, transparent 70%)',
            pointerEvents: 'none'
          }} />
        </div>

        {/* Quick Stats Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '16px',
          marginBottom: '36px'
        }}>
          <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: '20px', border: '1px solid rgba(15, 9, 28, 0.08)', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Mailer Studio Campaigns
            </div>
            <div style={{ fontSize: '28px', fontWeight: '800', color: '#d97706', marginTop: '6px' }}>
              {mailerCount}
            </div>
          </div>

          <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: '20px', border: '1px solid rgba(15, 9, 28, 0.08)', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Active Meta Access Links
            </div>
            <div style={{ fontSize: '28px', fontWeight: '800', color: '#0064E0', marginTop: '6px' }}>
              {metaRequestsCount}
            </div>
          </div>

          <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: '20px', border: '1px solid rgba(15, 9, 28, 0.08)', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Connected Artists & Pages
            </div>
            <div style={{ fontSize: '28px', fontWeight: '800', color: '#10b981', marginTop: '6px' }}>
              {metaClientsCount}
            </div>
          </div>

          <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: '20px', border: '1px solid rgba(15, 9, 28, 0.08)', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Total Leads Captured
            </div>
            <div style={{ fontSize: '28px', fontWeight: '800', color: '#8b5cf6', marginTop: '6px' }}>
              {totalLeadsCount}
            </div>
          </div>
        </div>

        {/* Section Heading */}
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '800', color: '#1f2937', margin: 0 }}>
            Available Louder Tools
          </h2>
          <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
            Select a workspace to open
          </span>
        </div>

        {/* Primary Tools Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
          gap: '24px',
          marginBottom: '40px'
        }}>
          {/* Tool Card 1: Mailer Studio */}
          <div style={{
            backgroundColor: '#ffffff',
            borderRadius: '24px',
            border: '1px solid rgba(217, 119, 6, 0.2)',
            padding: '28px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxShadow: '0 10px 30px -5px rgba(217, 119, 6, 0.08)',
            transition: 'all 0.25s ease'
          }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '16px',
                  backgroundColor: 'rgba(217, 119, 6, 0.1)',
                  color: '#d97706',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px'
                }}>
                  ✉️
                </div>
                <span style={{
                  backgroundColor: '#d97706',
                  color: '#ffffff',
                  fontSize: '11px',
                  fontWeight: '700',
                  padding: '4px 10px',
                  borderRadius: '20px'
                }}>
                  Core Tool
                </span>
              </div>

              <h3 style={{ fontSize: '20px', fontWeight: '800', color: '#1f2937', margin: '0 0 8px 0' }}>
                Louder Mailer Studio
              </h3>
              <p style={{ fontSize: '13px', color: '#6b7280', lineHeight: '1.6', margin: '0 0 24px 0' }}>
                newsletter builder, visual drag-and-drop template editor, GIF generator and element studio
              </p>
            </div>

            <button
              onClick={() => navigate('/dashboard')}
              style={{
                width: '100%',
                backgroundColor: '#d97706',
                color: '#ffffff',
                padding: '14px',
                borderRadius: '16px',
                border: 'none',
                fontWeight: '700',
                fontSize: '13px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                boxShadow: '0 4px 16px rgba(217, 119, 6, 0.25)',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#b45309'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#d97706'}
            >
              <span>Open Mailer Studio</span>
              <span>➔</span>
            </button>
          </div>

          {/* Tool Card 2: Meta Access Hub */}
          <div style={{
            backgroundColor: '#ffffff',
            borderRadius: '24px',
            border: '1px solid rgba(0, 100, 224, 0.2)',
            padding: '28px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxShadow: '0 10px 30px -5px rgba(0, 100, 224, 0.08)',
            transition: 'all 0.25s ease'
          }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '16px',
                  backgroundColor: 'rgba(0, 100, 224, 0.1)',
                  color: '#0064E0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px'
                }}>
                  🔗
                </div>
                <span style={{
                  backgroundColor: '#0064E0',
                  color: '#ffffff',
                  fontSize: '11px',
                  fontWeight: '700',
                  padding: '4px 10px',
                  borderRadius: '20px'
                }}>
                  Leads Tool
                </span>
              </div>

              <h3 style={{ fontSize: '20px', fontWeight: '800', color: '#1f2937', margin: '0 0 8px 0' }}>
                Meta Access Hub
              </h3>
              <p style={{ fontSize: '13px', color: '#6b7280', lineHeight: '1.6', margin: '0 0 24px 0' }}>
                Give artist managers a single link to grant Louder access to their Meta Facebook Pages, Ad Accounts, Insights, Meta Pixels, and Lead Generation forms.
              </p>
            </div>

            <button
              onClick={() => navigate('/meta-access')}
              style={{
                width: '100%',
                backgroundColor: '#0064E0',
                color: '#ffffff',
                padding: '14px',
                borderRadius: '16px',
                border: 'none',
                fontWeight: '700',
                fontSize: '13px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                boxShadow: '0 4px 16px rgba(0, 100, 224, 0.25)',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0055be'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#0064E0'}
            >
              <span>Open Meta Access Hub</span>
              <span>➔</span>
            </button>
          </div>
        </div>

        {/* Site-Wide Team & Permissions Management Banner */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '24px',
          padding: '24px 32px',
          border: '1px solid rgba(15, 9, 28, 0.08)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '44px',
              height: '44px',
              borderRadius: '14px',
              backgroundColor: 'rgba(217, 119, 6, 0.1)',
              color: '#d97706',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px'
            }}>
              👥
            </div>
            <div>
              <h3 style={{ fontSize: '16px', fontWeight: '800', color: '#1f2937', margin: '0 0 4px 0' }}>
                Site-Wide Team & Access Permissions
              </h3>
              <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>
                Manage user accounts, roles, and internal team members auto-assigned across Louder Mailer Studio and Meta Access Hub.
              </p>
            </div>
          </div>

          <button
            onClick={() => navigate('/admin')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 18px',
              backgroundColor: '#1f2937',
              color: '#ffffff',
              border: 'none',
              borderRadius: '12px',
              fontWeight: '700',
              fontSize: '13px',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#000000'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#1f2937'}
          >
            <span>Manage Team & Permissions</span>
            <span>➔</span>
          </button>
        </div>
      </main>
    </div>
  );
}
